import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { AccessibilityService } from '@core/services/accessibility.service';
import { CalcCssVarsService } from '@core/services/calc-css-vars.service';

@Component({
    selector: 'ncodp-accessibility-panel',
    standalone: true,
    templateUrl: './accessibility-panel.component.html',
    styleUrls: ['./accessibility-panel.component.scss'],
    imports: [AsyncPipe, TranslateModule, IonButton, IonIcon],
})
export class AccessibilityPanelComponent {
    private readonly accessibilityService = inject(AccessibilityService);
    public settings$ = this.accessibilityService.settings$;
    public panelVisible$ = this.accessibilityService.panelVisible$;
    private readonly calcCssVarsService = inject(CalcCssVarsService);
    public isMobileView$ = this.calcCssVarsService.isMobileView$;

    public toggleHighContrast(): void {
        this.accessibilityService.toggleHighContrast();
    }

    public increaseFontSize(): void {
        this.accessibilityService.increaseFontSize();
    }

    public decreaseFontSize(): void {
        this.accessibilityService.decreaseFontSize();
    }

    public resetSettings(): void {
        this.accessibilityService.resetSettings();
    }

    public hidePanel(): void {
        this.accessibilityService.hidePanel();
    }

    public getFontSizePercentage(fontSize: number): number {
        return Math.round(fontSize * 100);
    }
}
